import { useMemo } from 'react'
import { useSelector } from 'src/utils/store'
import { actions } from '../../StockManagementState'
import { useDispatch } from 'react-redux'
import { FlvProductInfoForRelease } from '../../StockManagementTypes'
import TableMui from 'src/components/TableMui'

const FlvProductsTable = () => {
  const { flvProductInfoForRelease, selectedFlvProducts } = useSelector((state) => state.stockManagement)
  const dispatch = useDispatch()

  const rows = useMemo(() =>
    flvProductInfoForRelease.map(({
      id, fulfillmentCenterName, idModel, productCode, productDescription, availableQuantityFromPunctual, totalStocks, availableStock, samedayLimit,
    }) => ({
      id, fulfillmentCenterName, idModel, productCode, productDescription, availableQuantityFromPunctual, totalStocks, availableStock, samedayLimit,
    })), [flvProductInfoForRelease])

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = rows.map((row) => {
        const currentProduct = flvProductInfoForRelease.find((product) => product.id === row.id)

        if (!currentProduct) return null

        const {
          id,
          idFulfillmentCenter,
          fulfillmentCenterName,
          idModel, productCode,
          productDescription,
          availableQuantityFromPunctual,
          totalStocks,
          availableStock,
          samedayLimit,
        } = currentProduct

        return {
          id,
          idFulfillmentCenter,
          fulfillmentCenterName,
          idModel,
          productCode,
          productDescription,
          availableQuantityFromPunctual,
          totalStocks,
          availableStock,
          samedayLimit,
        }
      })

      if (newSelected !== null) {
        dispatch(actions.setProperty({ property: 'selectedFlvProducts', value: newSelected as FlvProductInfoForRelease[] }))
      }

      return
    }
    dispatch(actions.setProperty({ property: 'selectedFlvProducts', value: [] }))
  }

  const handleClick = (_id: number) => {
    const selectedIndex = selectedFlvProducts.findIndex((product) => product.id === _id)

    if (selectedIndex === -1) {
      const productFromProducts = flvProductInfoForRelease.find((product) => product.id === _id)

      if (!productFromProducts) return

      const {
        id,
        idFulfillmentCenter,
        fulfillmentCenterName,
        idModel,
        productCode,
        productDescription,
        availableQuantityFromPunctual,
        totalStocks,
        availableStock,
        samedayLimit,
      } = productFromProducts

      if (productFromProducts) {
        const productToAdd: FlvProductInfoForRelease = {
          id,
          idFulfillmentCenter,
          fulfillmentCenterName,
          idModel,
          productCode,
          productDescription,
          availableQuantityFromPunctual,
          totalStocks,
          availableStock,
          samedayLimit,
        }
        dispatch(actions.setProperty({ property: 'selectedFlvProducts', value: [...selectedFlvProducts, productToAdd] }))
      }
    } else {
      const updatedSelectedProducts = selectedFlvProducts.filter((product) => product.id !== _id)
      dispatch(actions.setProperty({ property: 'selectedFlvProducts', value: updatedSelectedProducts }))
    }
  }

  return (
    <TableMui
      columns={[
        { id: 'fulfillmentCenterName', label: 'FC' },
        { id: 'idModel', label: 'ID modelo', minWidth: '188px' },
        { id: 'productCode', label: 'Código do produto' },
        { id: 'productDescription', label: 'Descrição do produto' },
        { id: 'availableQuantityFromPunctual', label: 'Quantidade disponibilizada' },
        { id: 'availableStock', label: 'Estoque disponível' },
        { id: 'totalStocks', label: 'Estoque total' },
        { id: 'samedayLimit', label: 'Limite Sameday' },
      ]}
      emptyLabel='Utilize o filtro para buscar produtos'
      rows={rows}
      rowCount={rows.length}
      selectedCount={selectedFlvProducts.length}
      enablePagination
      rowsPerPageLimit={100}
      selected={selectedFlvProducts.map((item) => item.id)}
      rowsPerPageOptions={[5, 10, 25, 30, 50, 100, 200]}
      hasCheckbox
      onSelectAllClick={handleSelectAllClick}
      onRowClick={handleClick}
      maxHeight='54vh'
      testId='flv-products-table-test-id'
    />
  )
}

export default FlvProductsTable
